
import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'
// import DragDropIndex from './Home/DragDropIndex';
import Payment from './Payment/Payment';
import { BrowserRouter, Route, Switch } from 'react-router-dom';


class App extends Component {

  constructor(props){
    super(props)
      this.state={
        
      }
  }

 
  render() {
  

    return (
      <div className="App">
         <BrowserRouter>
             <Switch>
             <Route exact path='/payment/:enquiryCode' component={Payment} />
             </Switch>  
         </BrowserRouter>
      </div>
    );
  }
}


export default App;